import type { ReactNode } from 'react';

import { cn } from '@/lib/utils';

export function Eyebrow({
  children,
  tone = 'default',
  center = false,
  className,
}: {
  children: ReactNode;
  /** `inverted` for use on dark surfaces (hero/CTA bands). */
  tone?: 'default' | 'inverted';
  center?: boolean;
  className?: string;
}): JSX.Element {
  return (
    <p
      className={cn(
        'flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em]',
        tone === 'inverted' ? 'text-accent' : 'text-primary',
        center && 'justify-center',
        className,
      )}
    >
      <span className="inline-block w-6 h-px bg-current shrink-0" aria-hidden="true" />
      {children}
    </p>
  );
}
